import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'input[appAutoFocus]',
  standalone: false,
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(private element: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit(): void {
    this.element.nativeElement.focus();
  }
}
